export interface District {
  id: string;
  name: string;
  lat: number;
  lng: number;
}

export interface Region {
  id: string;
  name: string;
  districts: District[];
}

export interface StateData {
  id: string;
  name: string;
  regions: Region[];
}

export const states: StateData[] = [
  {
    id: 'hirshabelle',
    name: 'Hirshabelle',
    regions: [
      {
        id: 'hiiraan',
        name: 'Hiiraan',
        districts: [
          { id: 'beledweyne', name: 'Beledweyne', lat: 4.7358, lng: 45.2036 },
          { id: 'jalalaqsi', name: 'Jalalaqsi', lat: 3.4321, lng: 45.6602 },
          { id: 'bulobarde', name: 'Bulobarde', lat: 3.8611, lng: 45.5822 }
        ]
      },
      {
        id: 'middle-shabelle',
        name: 'Middle Shabelle',
        districts: [
          { id: 'jowhar', name: 'Jowhar', lat: 2.7803, lng: 45.5006 },
          { id: 'balcad', name: 'Balcad', lat: 2.3667, lng: 45.3833 },
          { id: 'adan-yabaal', name: 'Adan Yabaal', lat: 2.7667, lng: 45.65 }
        ]
      }
    ]
  },
  {
    id: 'galmudug',
    name: 'Galmudug',
    regions: [
      {
        id: 'galgaduud',
        name: 'Galgaduud',
        districts: [
          { id: 'dhuusamareeb', name: 'Dhuusamareeb', lat: 5.5406, lng: 46.3856 },
          { id: 'adado', name: 'Adado', lat: 6.0964, lng: 46.6375 },
          { id: 'el-buur', name: 'El Buur', lat: 4.5667, lng: 46.6167 }
        ]
      },
      {
        id: 'mudug',
        name: 'Mudug',
        districts: [
          { id: 'galkayo', name: 'Galkayo', lat: 6.7697, lng: 47.4308 },
          { id: 'hobyo', name: 'Hobyo', lat: 5.3505, lng: 48.5268 },
          { id: 'jariiban', name: 'Jariiban', lat: 6.7833, lng: 47.7833 }
        ]
      }
    ]
  },
  {
    id: 'banaadir',
    name: 'Banaadir',
    regions: [
      {
        id: 'banaadir-region',
        name: 'Banaadir',
        districts: [
          { id: 'hodan', name: 'Hodan', lat: 2.0333, lng: 45.3167 },
          { id: 'wadajir', name: 'Wadajir', lat: 2.0167, lng: 45.3333 },
          { id: 'wabari', name: 'Wabari', lat: 2.05, lng: 45.3333 },
          { id: 'karan', name: 'Karan', lat: 2.0667, lng: 45.3 },
          { id: 'yaqshid', name: 'Yaqshid', lat: 2.0667, lng: 45.35 }
        ]
      }
    ]
  },
  {
    id: 'south-west',
    name: 'South West',
    regions: [
      {
        id: 'bay',
        name: 'Bay',
        districts: [
          { id: 'baidoa', name: 'Baidoa', lat: 3.1136, lng: 43.6499 },
          { id: 'buurhakaba', name: 'Buurhakaba', lat: 2.9667, lng: 44.2667 },
          { id: 'diinsoor', name: 'Diinsoor', lat: 2.4275, lng: 42.9769 }
        ]
      },
      {
        id: 'bakool',
        name: 'Bakool',
        districts: [
          { id: 'xudur', name: 'Xudur', lat: 4.118, lng: 43.8994 },
          { id: 'wajid', name: 'Wajid', lat: 3.8103, lng: 43.2422 }
        ]
      },
      {
        id: 'lower-shabelle',
        name: 'Lower Shabelle',
        districts: [
          { id: 'marka', name: 'Marka', lat: 1.7167, lng: 44.7667 },
          { id: 'afgooye', name: 'Afgooye', lat: 2.1394, lng: 45.1219 },
          { id: 'kurtunwaarey', name: 'Kurtunwaarey', lat: 1.7833, lng: 44.3667 }
        ]
      }
    ]
  },
  {
    id: 'jubaland',
    name: 'Jubaland',
    regions: [
      {
        id: 'gedo',
        name: 'Gedo',
        districts: [
          { id: 'garbahaarey', name: 'Garbahaarey', lat: 3.326, lng: 42.2166 },
          { id: 'luuq', name: 'Luuq', lat: 3.8021, lng: 42.5443 },
          { id: 'belet-xaawo', name: 'Belet Xaawo', lat: 4.2333, lng: 41.3167 }
        ]
      },
      {
        id: 'lower-juba',
        name: 'Lower Juba',
        districts: [
          { id: 'kismayo', name: 'Kismayo', lat: -0.3582, lng: 42.5454 },
          { id: 'afmadow', name: 'Afmadow', lat: 0.515, lng: 42.079 }
        ]
      },
      {
        id: 'middle-juba',
        name: 'Middle Juba',
        districts: [
          { id: 'buaale', name: "Bu'aale", lat: 1.0833, lng: 42.5833 },
          { id: 'jilib', name: 'Jilib', lat: 0.4864, lng: 42.7833 }
        ]
      }
    ]
  },
  {
    id: 'puntland',
    name: 'Puntland',
    regions: [
      {
        id: 'bari',
        name: 'Bari',
        districts: [
          { id: 'bosaso', name: 'Bosaso', lat: 11.2842, lng: 49.1816 },
          { id: 'qardho', name: 'Qardho', lat: 9.5041, lng: 49.0759 }
        ]
      },
      {
        id: 'nugaal',
        name: 'Nugaal',
        districts: [
          { id: 'garowe', name: 'Garowe', lat: 8.4054, lng: 48.4845 },
          { id: 'eyl', name: 'Eyl', lat: 7.9803, lng: 49.8164 }
        ]
      },
      {
        id: 'north-mudug',
        name: 'Mudug',
        districts: [{ id: 'galdogob', name: 'Galdogob', lat: 7.6667, lng: 47.2667 }]
      }
    ]
  }
];

export function getRegionsByState(stateId: string): Region[] {
  return states.find((s) => s.id === stateId)?.regions ?? [];
}

export function getDistrictsByRegion(stateId: string, regionId: string): District[] {
  return getRegionsByState(stateId).find((r) => r.id === regionId)?.districts ?? [];
}

export function getStateName(stateId: string): string {
  return states.find((s) => s.id === stateId)?.name ?? stateId;
}

export function getRegionName(stateId: string, regionId: string): string {
  return getRegionsByState(stateId).find((r) => r.id === regionId)?.name ?? regionId;
}

export function getDistrictName(stateId: string, regionId: string, districtId: string): string {
  return getDistrictsByRegion(stateId, regionId).find((d) => d.id === districtId)?.name ?? districtId;
}

export function getDistrictCoords(stateId: string, regionId: string, districtId: string): { lat: number; lng: number } | null {
  const district = getDistrictsByRegion(stateId, regionId).find((d) => d.id === districtId);
  return district ? { lat: district.lat, lng: district.lng } : null;
}
